import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import { EDIT_PAYROLL_COST, PAYROLL_COST } from '../utils/constants';
import * as Request from '../service/data-info-chart/requestsUtil';
import { PieChart, Pie, Cell, ResponsiveContainer } from 'recharts';
import edit from '../resources/images/estrategas/tools/edit.svg';
import { Button, Input, Modal, ModalBody, ModalFooter, ModalHeader, Label, Form, InputGroup, InputGroupAddon} from 'reactstrap';


class PayrollCost extends Component{

  callback = () => {
    this._Fetch()
  };

  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.createCatalogue = this.createCatalogue.bind(this);
    this.editPayrollCosts = this.editPayrollCosts.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.state = { total: null, loaded: true, modal: false, data: [], places: [], payrollPrev: [], catalog:'', key: 0 };
    this.catalog = [];
    this.data = [];
    this.values = [];
  }

  componentDidMount(){
    this._Fetch()
  }

  async _Fetch(){
    const resp = await Request.getFetch(PAYROLL_COST + this.props.date);
    this.setState({ data: resp.payrollPls, total: Number(resp.ammount)}, ()=>this.createCatalogue());
  }

  handleChange(evt, i) {
    this.values[i].value = Number(evt.target.value);
  }


  createCatalogue(){
    this.catalog = this.state.data.map((arr, index)=>( this.values.push({name: arr.name, value: null, bu: arr.businessUnit, type: arr.type}),
        <div className='m-3'>
          <Label for={arr.name}>{arr.name}:</Label>
          <InputGroup>
            <InputGroupAddon addonType="prepend">$</InputGroupAddon>
            <Input placeholder="ingrése valor en pesos" type='number' onChange={(evt)=>this.handleChange(evt, index)}
                   name={arr.name} id={arr.name}/>
          </InputGroup>
        </div>
    ));
  }

  toggle(){
    this.setState({ modal: !this.state.modal })
  }

  async editPayrollCosts(){
    const resp = this.values.map(data=>{
      if(data.value !== null && data.value !== undefined && data.value !== ''){
        let params = {
          'amount': data.value,
          'registerDate': this.props.date,
          'bussinesUnitId': data.bu,
          'type': data.type
        };
        return Request.postFetch(EDIT_PAYROLL_COST, params)
      }
    });
    await Promise.all(resp);
    this.toggle();
    await this._Fetch();

  }

  render() {

    let payrollOperative = 0;
    let  sumaryData = [];

    if (this.state.data !== []) {


      this.state.data.forEach((place, index) => {
        if (place.type === 1) {
          payrollOperative += place.ammount;
        }
      });


      this.state.data.map(arr=>{
        if(arr.type !== 1 ){
          sumaryData.push({ammount: arr.ammount, name: arr.name})
        }
      });
      sumaryData.push({ammount: payrollOperative, name: 'Operación'});
      this.data = sumaryData.map(data=>{
        return { name: data.name, value: data.ammount }
      });
    }

    const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042'];

    const RADIAN = Math.PI / 180;
    const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, index, }) => {
      const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
      const x = cx + radius * Math.cos(-midAngle * RADIAN);
      const y = cy + radius * Math.sin(-midAngle * RADIAN);

      return (
        <text x={x} y={y} fill="white" textAnchor={x > cx ? 'start' : 'end'} dominantBaseline="central">
          {`${(percent * 100).toFixed(2)}%`}
        </text>
      );
    };

    if(this.state.total !== 0.00 && this.state.total !== null && this.state.total !== undefined){
      this.pieChart = <ResponsiveContainer width="100%" height={400}>
        <PieChart width={400} height={400}>
          <Pie
            data={this.data}
            labelLine={false}
            label={renderCustomizedLabel}
            outerRadius={200}
            fill="#8884d8"
            dataKey="value"
          >
            {this.data.map((entry, index) => <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />)}
          </Pie>
        </PieChart>
      </ResponsiveContainer>;
      this.label = this.data.map((label, index)=>{
        return <div className='d-flex '><div className={`label-box-color-${index}`}/><p>{label.name}</p></div>
      });
    } else{
      this.pieChart = <div className='container text-center'>
        <h1> Sin información</h1>
      </div>;
      this.label = '';
    }


    let classUser = this.props.authorization ? 'quality-edit' : 'quality-edit-unauthorized';

    return (
      <div className='container-fluid pt-4' key={this.state.key}>
        <div className='container-fluid hum-res-title-1'>
          Costo de nómina
        </div>
        <div className={classUser}>
          <img src={edit} title="Editar" alt=" " onClick={this.toggle}/>
        </div>
        <Modal isOpen={this.state.modal} toggle={this.toggle}>
          <ModalHeader className='header-modal'
                       toggle={this.toggle}>Periodo {this.props.dateModal}</ModalHeader>
          <ModalBody>
            <p>Actualizar costo de nómina</p>
            <Form>
              {this.catalog}
            </Form>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={this.editPayrollCosts}>Aceptar</Button>{' '}
            <Button color="danger" onClick={this.toggle}>Cancelar</Button>
          </ModalFooter>
        </Modal>
        <div className='container-fluid mb-5'>
          <div className='row' key={this.state.key}>
            <div className='flex-column'>
              {this.label}
            </div>
            {this.pieChart}
          </div>
        </div>
      </div>
    );
  }

}

export default PayrollCost;



// WEBPACK FOOTER //
// ./src/charts/payrollCost.js